function luminance(hex: string) {
  const rgb = [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16) / 255);
  const linear = rgb.map((v) =>
    v <= 0.04045 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4,
  );
  return linear[0]! * 0.2126 + linear[1]! * 0.7152 + linear[2]! * 0.0722;
}
/** Floating controls have no plate: adapt ink to the workspace and outline the glyphs. */
export function updateDockContrast(root: HTMLElement, workspace: string) {
  if (root.dataset.dockWorkspace === workspace) return;
  root.dataset.dockWorkspace = workspace;
  const background = luminance(workspace);
  const contrast = (color: string) => {
    const ink = luminance(color);
    return (
      (Math.max(ink, background) + 0.05) / (Math.min(ink, background) + 0.05)
    );
  };
  const dark = contrast("#f1f5ff") > contrast("#172033");
  const ink = dark ? "#f1f5ff" : "#172033";
  const accent = dark ? "#8dcaff" : "#185ad4";
  root.style.setProperty("--native-floating-ink", ink);
  root.style.setProperty(
    "--native-floating-active",
    contrast(accent) >= 3 ? accent : ink,
  );
  root.style.setProperty(
    "--native-floating-outline",
    dark ? "#111827" : "#ffffff",
  );
}
